/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import IconV2 from "uis/Icon/Icon_v2/icon";

const Card = styled.div<{ color: string }>`
    background: ${(props) => props.color};
    flex: 1;
    border-radius: 15px;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;

    .title {
        color: var(--Neutral-900, #1b1d1f);
        font-size: 25px;
        font-weight: 700;
        margin-bottom: 8px;
    }

    .description {
        color: var(--Neutral-500, #6e7781);
        font-size: 12px;
        font-weight: 400;
        white-space: pre-line;
        margin-bottom: 40px;
    }
`;

export default function CheckInCheckOut({ lang }: { lang: "kor" | "eng" }) {
    return (
        <div
            css={css`
                display: flex;
                gap: 15px;
            `}
        >
            <Card color="#F2FFFD">
                <p className="title">{lang === "kor" ? "체크인" : "Check-In"}</p>
                <p className="description">
                    {lang === "kor" ? `체크인을 통해\n담당자를 불러드릴게요.` : `Check in, and\nwe'll call the host for you.`}
                </p>
                <IconV2
                    name="login"
                    size={50}
                    color="#00DBC1"
                    style={{ rotate: "180deg", width: "min-content", height: "min-content", marginLeft: "auto" }}
                />
            </Card>
            <Card color="#FFF6F6">
                <p className="title">{lang === "kor" ? "체크아웃" : "Check-Out"}</p>
                <p className="description">{lang === "kor" ? `방문을\n마치셨나요?` : `Have you\nfinished your visit?`}</p>
                <IconV2
                    name="logout"
                    size={50}
                    color="#FF6060"
                    style={{ width: "min-content", height: "min-content", marginLeft: "auto" }}
                />
            </Card>
        </div>
    );
}
